import { inject } from '@angular/core';
import { ActiveOrderPhaseDsService } from '@app/core/data-services';
import { map } from 'rxjs/operators';

export const toolCheckoutGuard = () => {
  const activeOrderPhaseDsService: ActiveOrderPhaseDsService = inject(ActiveOrderPhaseDsService);
  return activeOrderPhaseDsService.getKpisConfirmed().pipe(map((areKpisConfirmed) => !!areKpisConfirmed));
};
